import { useLingui } from '@lingui/react';

import { StatusBadge } from '@/components/ui/status-badge';
import { emailStatusConfig } from './emailStatusLabels';

/** The delivery state of one invoice or dunning email, one look on every billing page. */
export function EmailStatusBadge({ status, className }: { status: string | undefined; className?: string }) {
  const { i18n } = useLingui();
  const config = emailStatusConfig(status);
  return <StatusBadge tone={config.tone} icon={config.icon} label={i18n._(config.label)} className={className} />;
}
